import { useEffect, useRef } from 'react';

import { store } from 'redux/store';
import { setRequestTriggered } from 'redux/reducers/meteorologyFieldsClassicComparatorControlPanelReducer';
import useGetImagesParams from './useGetImagesParams';

/**
 * Auto-consulta ao abrir o Comparador Clássico (#1822, item 5.3).
 *
 * O preenchimento automático (variável + modelos em
 * useApplyClassicComparatorOpenDefaults, período em
 * useApplyClassicComparatorDefaultInterval) deixava tudo escolhido mas parava aí:
 * o usuário ainda tinha que clicar em "Realizar consulta".
 *
 * Não é preciso observar cada campo para saber quando a cascata acabou:
 * `useGetImagesParams` só devolve params quando TODOS os campos de base e
 * confronto estão definidos, então "params deixou de ser undefined" é exatamente
 * o fim do preenchimento. Despachar `setRequestTriggered` é o mesmo caminho do
 * botão — quem dispara a request de fato é o `useImages`.
 *
 * O ref `done` mantém isto como um evento de abertura: depois da primeira
 * consulta, trocar filtro volta a exigir o clique no botão (regra da Bruna de que
 * a consulta do Clássico é manual).
 */
export default function useApplyClassicComparatorOpenQuery() {
  const params = useGetImagesParams();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    if (!params) return;

    done.current = true;
    store.dispatch(setRequestTriggered(true));
  }, [params]);
}
